import React, {useEffect, useState} from 'react';
import {ThemeProvider} from "@material-ui/core/styles";
import {createTheme} from '@material-ui/core/styles'
import AppBar from "../appBar";
import TopBand from "../../component/topBand/TopBand";
import Why from "../../component/why";
import OfferAndExpertiseContainer from "../../component/offerAndExpertiseContainer";
import Contact from "../../component/contact";
import Footer from "../footer";
import DialogCustom from "../../component/common/DialogCustom";
import MentionLegale from "../../component/mentionLegale";
import Cookies from "../../component/cookies";
import TermsOfSale from "../../component/termsOfSale";
import PlanSite from "../../component/planSite";

const refTop = React.createRef();
const refWhy = React.createRef();
const refServices = React.createRef();

function MainLayout() {
    const theme = createTheme({
        typography: {
            fontFamily: [
                '"Segoe UI"',
                '-apple-system',
                'BlinkMacSystemFont',
                'Roboto',
                '"Helvetica Neue"',
                'Arial',
                'sans-serif',
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
            ].join(','),
            h1: {
                fontSize: 26,
                fontWeight: 500,
                lineHeight: '35px',
            },
            h2: {
                fontSize: 22,
                fontWeight: 500,
                lineHeight: '47px',
            },
            subtitle1: {
                fontSize: 18,
                fontWeight: 500,
                lineHeight: '33px',
            },
            subtitle2: {
                fontSize: 18,
                lineHeight: '32px',
            },
        },
    });
    const [dialogProps, setDialogProps] = useState({
        isOpen: false,
        children: <MentionLegale/>,
        title: ""
    });

    useEffect(() => {
        setTimeout(function () {
            switch (window.location.pathname) {
                case "/":
                    refTop.current.scrollIntoView({behavior: "smooth"});
                    break;
                case "/pourquoi-cyklad":
                    refWhy.current.scrollIntoView({behavior: "smooth"});
                    break;
                case "/services":
                    refServices.current.scrollIntoView({behavior: "smooth"});
                    break;
                case "/mention-legale":
                    setDialogProps({
                        isOpen: true,
                        children: <MentionLegale/>,
                        title: "Mention Légales"
                    });
                    break;
                case "/cookies":
                    setDialogProps({
                        isOpen: true,
                        children: <Cookies/>,
                        title: "Cookie Policy"
                    });
                    break;
                case "/conditions-utilisation":
                    setDialogProps({
                        isOpen: true,
                        children: <TermsOfSale/>,
                        title: "Condition d'Utilisation"
                    });
                    break;
                case "/plan-du-site":
                    /*setDialogProps({
                        isOpen: true,
                        children: <TermsOfSale/>,
                        title: "Plan du site"
                    });*/
                    break;
                default:
            }
        }, 500)
    }, []);

    function scrollTo(str) {
        window.history.pushState({}, null, str);
        switch (str) {
            case "/":
                refTop.current.scrollIntoView({behavior: "smooth"});
                break;
            case "/pourquoi-cyklad":
                refWhy.current.scrollIntoView({behavior: "smooth"});
                break;
            case "/services":
                refServices.current.scrollIntoView({behavior: "smooth"});
                break;
            default:
        }
    }

    function onClickOpenDialog(str) {
        window.history.pushState({}, null, str);
        switch (str) {
            case "/mention-legale":
                setDialogProps({
                    isOpen: true,
                    children: <MentionLegale/>,
                    title: "Mention Légales"
                });
                break;
            case "/cookies":
                setDialogProps({
                    isOpen: true,
                    children: <Cookies/>,
                    title: "Cookies"
                });
                break;
            case "/conditions-utilisation":
                setDialogProps({
                    isOpen: true,
                    children: <TermsOfSale/>,
                    title: "Condition d'Utilisation"
                });
                break;
            case "/plan-du-site":
                setDialogProps({
                    isOpen: true,
                    children: <PlanSite/>,
                    title: "Plan du site"
                });
                break;
            default:
        }
    }

    return (
        <ThemeProvider theme={theme}>
            <div ref={refTop} style={{
                backgroundAttachment: "fixed",
                backgroundImage: 'url(/image/parallaxe/bg.png)',
                backgroundSize: '100% 100%',
            }}>
                <AppBar scrollTo={scrollTo}/>
                    <TopBand/>
                    <Why ref={refWhy}/>
                    <OfferAndExpertiseContainer ref={refServices}/>
                    <Contact/>
            </div>
            <Footer scrollTo={scrollTo} onClickOpenDialog={onClickOpenDialog}/>
            <DialogCustom
                close={() => setDialogProps({...dialogProps, isOpen: false, children: null})}
                open={dialogProps.isOpen}
                title={dialogProps.title}
                children={dialogProps.children}
            />
        </ThemeProvider>
    )
}

export default MainLayout
